import { memo } from 'react';
import { DocumentScanner, People, SettingsSuggest } from '@mui/icons-material';
import { IconWrapper, Wrapper } from './AdminIconsArray.styles';

interface AdminIconsArrayProps {
  value: string[];
  asColumns?: boolean;
}

interface PermissionIconsProps {
  value: string[];
}

const permissionIcons = [
  {
    permission: 'TemplateAdmin',
    icon: DocumentScanner,
  },
  {
    permission: 'SettingAdmin',
    icon: SettingsSuggest,
  },
  {
    permission: 'UserAdmin',
    icon: People,
  },
];

const PermissionIcons = memo(({ value }: PermissionIconsProps) => {
  return value.map((permission, index) => {
    const Icon = permissionIcons.find((icon) => icon.permission === permission)?.icon;

    if (!Icon) return null;

    return (
      <IconWrapper key={index}>
        <Icon fontSize="small" />
      </IconWrapper>
    );
  });
});

export const AdminIconsArray = memo(({ value, asColumns = false }: AdminIconsArrayProps) => {
  if (!value || value.length === 0 || !Array.isArray(value)) return null;

  return (
    <Wrapper columns={asColumns}>
      <PermissionIcons value={value} />
    </Wrapper>
  );
});
